export default {
    list: {
        title: 'Tickets',
        empty: {
            title: 'No tickets',
            subtitle: 'Create the first ticket or import a CSV.',
            cta: '+ New ticket'
        },
        columns: {
            code: 'Code',
            used: 'Used',
            buyer: 'Buyer',
            event: 'Event',
            ticketset: 'Set',
            createdAt: 'Created',
            usedAt: 'Used at',
            phone: 'Phone',
            email: 'Email',
            firstName: 'First name',
            lastName: 'Last name',
            ticketNumber: 'Ticket number',
            validUntil: 'Valid until',
            boughtAt: 'Bought at'
        }
    },
    verify: {
        title: 'Ticket verification',
        subtitle: 'Enter a ticket code to view detail and usage.',
        enterCode: 'Ticket code',
        verify: 'Verify',
        newSearch: 'New search',
        notFound: 'Ticket not found',
        error: 'Verification failed.',
        found: 'Found',
        email: 'E-mail',
        entries: 'Entries',
        people: 'People',
        entryPause: 'Entry pause (min)',
        purchased: 'Purchased',
        validUntil: 'Valid until',
        event: 'Event',
        ticketset: 'Ticketset',
        price: 'Price tier',
        zones: 'Zones',
        noZones: 'No zones',
        slots: 'Slots',
        noSlots: 'No slots',
        usageForZone: 'Usage for zone',
        remains: 'Remains',
        usageLogs: 'Usage history',
        showDebug: 'Q',
        debugData: 'Raw data'
    },
    filters: {
        search: 'Search (code, name, email)',
        event: 'Event',
        ticketset: 'Ticket set',
        used: 'Used status',
        usedAny: 'Any',
        usedYes: 'Used',
        usedNo: 'Unused'
    },
    usedLabel: {
        used: 'Used',
        unused: 'Unused'
    },
    edit: {
        titleEdit: 'Edit ticket · {code}',
        unsavedChanges: 'You have unsaved changes. Close anyway?'
    },
    import: {
        title: 'Import tickets',
        steps: {
            upload: '1. Upload',
            mapping: '2. Mapping',
            preview: '3. Preview',
            progress: '4. Importing',
            result: '5. Done'
        },
        dropzone: 'Drop a CSV or Excel file here or click',
        columns:
            'CSV or XLSX, with or without a header row. Columns are mapped in the next step; missing values can be filled with a fixed value.',
        eventRequired: 'Select an event for the import',
        event: 'Event',
        eventPlaceholder: 'Select event',
        rowCount: '{n} rows',
        ticketsetCount: '{n} sets',
        priceCount: '{n} prices',
        validRows: '{n} valid',
        invalidRows: '{n} errors',
        confirmImport: 'Import {n} tickets',
        importing: 'Importing {n} tickets…',
        truncated: 'Showing first 100 rows of {n}.',
        onlyCsv: 'Only CSV files',
        onlyCsvXlsx: 'Only CSV, XLS or XLSX files',
        success: 'Import successful',
        failed: 'Import failed',
        failedNothingSaved: 'Import did not run — nothing was saved',
        blockingErrors: 'The import is atomic; {n} errors must be fixed before sending:',
        rowLabel: 'Row {n}',
        backToList: 'Back to list',
        backToMapping: 'Back to mapping',
        anotherFile: 'Upload another file',
        mapping: {
            hasHeader: 'First row is a header',
            delimiter: 'Delimiter',
            encoding: 'Encoding',
            sheet: 'Sheet',
            headerUnsureAssumedHeader: 'We treat the first row as a header — please verify',
            headerUnsureAssumedData: 'We treat the first row as data — please verify',
            headerUnsureHint:
                'Check the preview above to see whether the guess is right. If not, toggle “First row is a header” or adjust the number of ignored rows.',
            headerConfirm: 'That is correct',
            confirmHeaderFirst: 'First confirm whether the first row contains a header.',
            sampleTitle: 'File preview',
            headerRowLabel: 'header',
            skippedRowLabel: 'skipped',
            skipRows: 'Ignore rows at start',
            skipTrailingRows: 'Ignore rows at end',
            fromColumn: 'Column from file',
            fixedValue: 'Fixed value',
            existingTicketset: 'Existing ticket set',
            existingPrice: 'Existing price',
            selectExisting: 'Select from list',
            noExisting: 'Nothing available in this event yet',
            pickEventFirst: 'Select an event first to pick an existing ticket set.',
            pickTicketsetFirst: 'Select an existing ticket set first to pick a price.',
            autoFromExisting: 'Filled from the selected item',
            empty: 'Leave empty',
            selectColumn: 'Select column',
            columnN: 'Column {n}',
            preview: 'Preview',
            valuePlaceholder: 'Value for all rows',
            appliesToAll: 'Applied to every row',
            missingRequired: 'Fill in required fields: {fields}',
            continue: 'Continue to preview',
            reason: {
                alias: 'Matched by column name',
                fuzzy: 'Matched by similar column name',
                content: 'Matched by data content',
                position: 'Matched by column order',
                none: ''
            }
        },
        result: {
            created: 'Tickets created',
            skipped: 'Skipped (duplicates)',
            ticketsetsCreated: 'Ticket sets created',
            pricesCreated: 'Prices created',
            atomicHint:
                'The file contains {n} errors. The import is atomic: until all of them are fixed, no ticket is saved.',
            errorsTruncated: 'Showing {shown} of {total} errors.',
            downloadErrors: 'Download all errors (CSV)'
        },
        preview: {
            row: '#',
            status: 'Status',
            errors: 'Errors',
            cols: {
                code: 'Code',
                priceId: 'Price ID',
                priceName: 'Price',
                priceNoDph: 'Price excl. VAT',
                priceDph: 'VAT',
                priceAmount: 'Amount',
                currency: 'Currency',
                ticketsetId: 'Set ID',
                ticketsetName: 'Set',
                orderId: 'Order',
                paymentSource: 'Payment source',
                paymentType: 'Payment type',
                orderDate: 'Order date',
                firstName: 'First name',
                lastName: 'Last name',
                phone: 'Phone',
                email: 'Email'
            }
        }
    },
    bulk: {
        selected: '{n} selected',
        deleteAll: 'Delete selected',
        addToClipboard: 'Add selected to clipboard'
    },
    actions: {
        import: 'Import CSV',
        export: 'Export CSV',
        addToClipboard: 'To clipboard'
    },
    detail: {
        addToClipboard: 'Add to clipboard'
    },
    confirm: {
        deleteTitle: 'Delete ticket?',
        deleteMessage: 'Ticket {code} will be permanently removed.',
        deleteBulkTitle: 'Delete selected tickets?',
        deleteBulkMessage: '{n} tickets will be permanently removed.'
    },
    toasts: {
        saved: 'Ticket saved',
        created: 'Ticket created',
        deleted: 'Ticket deleted',
        bulkDeleted: '{n} tickets deleted',
        exported: 'Export ready',
        exportedPage: '{n} tickets exported from current page',
        addedToClipboard: 'Ticket added to clipboard',
        bulkAddedToClipboard: 'Added {n} tickets to clipboard'
    }
}
